import { Component, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-banner-info',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './banner-info.component.html',
  styleUrls: ['./banner-info.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BannerInfoComponent {
  public closeBanner = output();
  public showEditInfo = output();

  public handleCloseClick() {
    this.closeBanner.emit();
  }
  
  public handleBannerClick() {
    this.showEditInfo.emit();
  }
}
